<div class="page-wrapper">
  <div class="params-wrapper">
    <div class="buttons-wrapper">
      <!-- <frg-button (activated)="getLastPatient()">Patient en cours</frg-button> -->
      <frg-button (activated)="openPatientSearch()">Rechercher un patient</frg-button>
    </div>
    <div class="params-part">
      <div class="left-part">
        <!-- Champ patient -->
         <div class="patient-selected">
          <frg-form-input *ngIf="formGroup" id="patient" label="Patient" type="text" [formGroup]="formGroup"
          [control]="formGroup.get('patient')" [disabled]="true" [deletable]="false">
          </frg-form-input>
          <button *ngIf="this.SelectedPatient" mat-icon-button color="warn" (click)="onDeletePatient()" class="button-deletePatient">
            <mat-icon>close</mat-icon>
          </button>
         </div>


        <!-- Champ description -->
        <frg-form-input *ngIf="formGroup" id="description" label="Description" type="text" [formGroup]="formGroup"
          [control]="formGroup.get('description')"></frg-form-input>

        <!-- Champ liste déroulante types -->
        <frg-form-input *ngIf="formGroup" id="type" label="Type" [selectValue]="eventTypesLabel" type="text"
          [formGroup]="formGroup" [control]="formGroup.get('type')"></frg-form-input>

        <div class="resources-wrapper">
          <div class="label">Ressources</div>
          <div class="resources-select" *ngIf="formGroup" [formGroup]="formGroup">
            <ng-select [items]="resourcesLabel" formControlName="resource" [multiple]="true"></ng-select>
          </div>
        </div>
      </div>
      <div class="right-part">
        <div class="date-picker-wrapper">
          <div class="picker-label">Période</div>
          <div class="date-start-end">
            <div class="date-picker-label">
              <label>Du</label>
              <div class="date-picker" *ngIf="formGroup">
                <mat-form-field appearance="fill">
                  <input #dateDu matInput [matDatepicker]="dateStartPicker" placeholder="JJ/MM/YYYY" [formControl]="formGroup.get('dateStart')" rInputMask="99/99/9999">
                  <mat-datepicker-toggle matSuffix [for]="dateStartPicker"></mat-datepicker-toggle>
                  <mat-datepicker #dateStartPicker></mat-datepicker>
                </mat-form-field>
              </div>
            </div>

            <div class="date-picker-label">
              <label>au</label>
              <div class="date-picker" *ngIf="formGroup">
                <mat-form-field appearance="fill">
                  <input #dateAu matInput [matDatepicker]="dateEndPicker" placeholder="JJ/MM/YYYY" [formControl]="formGroup.get('dateEnd')" rInputMask="99/99/9999">
                  <mat-datepicker-toggle matSuffix [for]="dateEndPicker"></mat-datepicker-toggle>
                  <mat-datepicker #dateEndPicker></mat-datepicker>
                </mat-form-field>
              </div>
            </div>

          </div>
        </div>
        <div class="hour-picker-wrapper">
          <div class="picker-label">Horaires</div>
          <div class="hour-start-end" *ngIf="formGroup">
            <div class="date-picker-label">
              <label>De</label>
              <ngx-timepicker-field (timeChanged)="timeChanged($event, 'timeStart')"
                [defaultTime]="formGroup.get('timeStart').value" [format]="24" [cancelBtnTmpl]="cancelBtn"
                [confirmBtnTmpl]="confirmBtn" [clockTheme]="customTimePickerTheme" [toggleIcon]="icon">
              </ngx-timepicker-field>
            </div>
            <div class="date-picker-label">
              <label>à</label>
              <ngx-timepicker-field (timeChanged)="timeChanged($event, 'timeEnd')"
                [defaultTime]="formGroup.get('timeEnd').value" [format]="24" [cancelBtnTmpl]="cancelBtn"
                [confirmBtnTmpl]="confirmBtn" [clockTheme]="customTimePickerTheme" [toggleIcon]="icon">
              </ngx-timepicker-field>
            </div>
          </div>
        </div>

        <ng-template #cancelBtn>
          <div class="custom-btn">Annuler</div>
        </ng-template>
        <ng-template #confirmBtn>
          <div class="custom-btn">OK</div>
        </ng-template>
        <ng-template #icon>
          <svg width="16" height="16" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fill-rule="evenodd" clip-rule="evenodd"
              d="M11 22C4.92487 22 0 17.0751 0 11C0 4.92487 4.92487 0 11 0C17.0751 0 22 4.92487 22 11C22 17.0751 17.0751 22 11 22ZM11 20C15.9706 20 20 15.9706 20 11C20 6.02944 15.9706 2 11 2C6.02944 2 2 6.02944 2 11C2 15.9706 6.02944 20 11 20ZM16 10H12V5H10V12H16V10Z"
              fill="#a9b5c1" />
          </svg>
        </ng-template>

        <!-- Champ liste déroulante statuts -->
        <frg-form-input *ngIf="formGroup" id="status" label="Statut du RDV" [selectValue]="statusLabelList" type="text"
          [formGroup]="formGroup" [control]="formGroup.get('status')"></frg-form-input>

        <div class="without-patient-only">
          <label class="checkbox">
            <input *ngIf="formGroup" [formGroup]="formGroup" [formControl]="formGroup.get('withoutPatientOnly')"
              type="checkbox">
            <span class="checkMark"></span>
          </label>
          <span class="checkbox-label">Afficher uniquement les rendez-vous sans patients</span>
        </div>
        <div class="unplanned-events-only">
          <label class="checkbox">
            <input *ngIf="formGroup" [formGroup]="formGroup" [formControl]="formGroup.get('unplannedEventsOnly')"
              type="checkbox">
            <span class="checkMark"></span>
          </label>
          <span class="checkbox-label">Afficher uniquement les rendez-vous à planifier</span>
        </div>
      </div>
    </div>
    <div class="button-search-event-wrapper">
      <frg-button (activated)="doSearchEvents()">Lancer la recherche</frg-button>
      <frg-button (activated)="doPrintSearchResults()" *ngIf="searchResult && searchResult.objects.length > 0">Imprimer</frg-button>
    </div>
  </div>
  <div class="result-part">
    <div class="result-table" *ngIf="searchResult && searchResult.objects.length > 0">

      <frg-table
        [keysBody]="searchResult"
        [keysColumn]="patientEventsColumnTable"
        [isRowsClickable]="true"
        (onClickRow)="goToEventDetails($event)"
        (onChangePage)="doSearchEvents($event)"
        (onSort)="onSort($event)"
      ></frg-table>
      <div>Nombre de rendez-vous: {{searchResult.total}}</div>
    </div>
    <div *ngIf="searchResult && searchResult.objects.length <= 0" class="no-result">Aucun rendez-vous trouvé</div>
    <div *ngIf="!searchResult" class="no-result">Le résultat de votre recherche s'affichera ici</div>
  </div>
</div>
